import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const now = new Date();
  const day = now.getDate();
  const month = now.toLocaleString('en-us', { month: 'short' }).toUpperCase();
  const year = now.getFullYear();

  return (
    <header>
      <div className='titlenav'>
        <h1 className='sitetitle'>Important Tasks</h1>

        <ul className='nav'>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/about'>About</Link>
          </li>
        </ul>
      </div>

      <div className='header-main'>
        <div className='dateDiv'>
          <h1 className='date'>{day}</h1>
          <div className='dateDiv2'>
            <span className='month'>{month}</span>
            <span>{year}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
